import { styled } from 'stitches.config'

export const HomeRoot = styled('div', {
    backgroundColor: '$accent-white',
})